import {
  AfterViewInit,
  Component,
  ElementRef,
  EventEmitter,
  Input,
  OnDestroy,
  OnInit,
  Output,
  ViewChild,
} from "@angular/core";
import { AirbnbLinkType, HouseType, RelationService } from "../relation.service";
import _ from "lodash";
import { debounceTime, filter, first, map, takeUntil } from "rxjs";
import { fromEvent, merge, Subject } from "rxjs";
import { airbnbInventoryDoc } from "@root/config";
import { AppService } from "@root/app.service";
import { HostexModel, HouseModel } from "../base-house-relation/base-house-relation.component";
import { routes } from "@root/common/routes";
import { HttpClient } from "@angular/common/http";
import { UntypedFormBuilder, UntypedFormGroup } from "@angular/forms";

@Component({
  selector: "host-house-relation-right-panel",
  templateUrl: "./house-relation-right-panel.component.html",
  styleUrls: ["./house-relation-right-panel.component.scss"],
})
export class HouseRelationRightPanelComponent implements OnInit, AfterViewInit, OnDestroy {
  readonly routes = routes;
  @ViewChild("scrollContainer") scrollContainer: ElementRef;
  @ViewChild("listContainer") listContainer: ElementRef;
  @Output() onLink: EventEmitter<{
    node: Node;
    data: { from: HouseModel; to: HostexModel };
  }> = new EventEmitter();
  // @Output() onRefreshChannelHouses: EventEmitter<{
  //   list: string;
  //   platform: number;
  // }> = new EventEmitter();
  @Output() onRefreshChannelHouses: EventEmitter<number> = new EventEmitter();
  @Input() tabIndex = 0;
  page = 1;
  pageSize = 50;
  listOfHouses: HouseModel[] = [];
  listOfPlatforms = [-1];
  currentHouseList: HouseModel[] = []; // 当前渠道房源，随渠道变化而变
  leftPanelSelectedItem: HostexModel;
  get currentChannel() {
    return this.listOfPlatforms?.[this.tabIndex];
  }

  get isInternational() {
    return this.app.app.international;
    // return this.internationalService.isInternational();
  }

  get airbnbInventoryDoc() {
    return airbnbInventoryDoc(this.isInternational);
  }

  trackById = (index, item) => item.id;

  hasMoreDataFlag = true;
  hasAccount = false; // 是否已经关联账号
  form: UntypedFormGroup = this.fb.group({
    keyword: null,
  });
  private destroy$ = new Subject();

  constructor(
    private fb: UntypedFormBuilder,
    private relationSrv: RelationService,
    private http: HttpClient,
    private app: AppService, // private internationalService: InternationalService
  ) {}

  ngOnInit() {
    this.subscribeFormChange();

    this.relationSrv.channelTabChange$.pipe(takeUntil(this.destroy$)).subscribe((index) => (this.tabIndex = index));
    this.relationSrv.typeTabChange$.pipe(takeUntil(this.destroy$)).subscribe((index) => this.fetchHouseList());

    this.relationSrv.leftPanelSelectItem$.pipe(takeUntil(this.destroy$)).subscribe((item) => {
      this.leftPanelSelectedItem = item;
    });

    this.relationSrv.removeCardFromHousesRaw$.pipe(takeUntil(this.destroy$)).subscribe(({ card }) => {
      console.log("remove");
      _.remove(this.listOfHouses, (house) => house === card);
      this.refreshCurrentHouseList();
    });

    this.relationSrv.addCardToHousesRaw$.pipe(takeUntil(this.destroy$)).subscribe(({ card, hostex }) => {
      this.listOfHouses.unshift(card);
      console.log("here: ", card, " hostex: ", hostex);

      // _.remove(this.listOfHouses, (house) => house === card);
      this.refreshCurrentHouseList();
    });

    /** 首次关联房间和房型需要刷新房源列表 */
    merge(
      this.relationSrv.removeCardFromHousesRaw$.pipe(
        filter(({ hostex }) => hostex.type === "house"),
        first(),
      ),
      this.relationSrv.removeCardFromHousesRaw$.pipe(
        filter(({ hostex }) => hostex.type === "house_type"),
        first(),
      ),
      this.relationSrv.leftPanelSelectItem$.pipe(map((item) => ({ hostex: item }))),
    ).subscribe((rst) => {
      console.log("first remove: ", rst);
      const { hostex } = rst;
      const params = {};
      if (hostex.type === "house") {
        Object.assign(params, { property_id: hostex.id });
      } else {
        Object.assign(params, { room_type_id: hostex.id });
      }
      this.fetchHouseList(params);
    });
  }

  ngAfterViewInit() {
    this.fetchHouseList();
    // this.addCardToThirdpartyHouses$.pipe(takeUntil(this.destroy$)).subscribe();
    // this.removeCardFromThirdpartyHouses$.pipe(takeUntil(this.destroy$)).subscribe();
    // this.click$.pipe(takeUntil(this.destroy$)).subscribe();

    this.initScrollContainerListener();
  }

  private subscribeFormChange() {
    this.form.valueChanges.subscribe((rst) => {
      this.fetchHouseList();
    });
  }

  private fetchHouseList(extra?: { property_id?: number; room_type_id?: number }) {
    const params = { ...this.form.value, ...extra };
    this.http.get("/api/listing_linking/unlinking_listings", { params }).subscribe((res: any) => {
      // return this.syncSrv.getHouseList({ page: 1, page_size: 10000 }).subscribe((res) => {
      const list = res?.data?.list || [];
      const platforms: Set<number> = new Set(list.map((item) => item.thirdparty_type));
      this.listOfHouses = this.updateHouseList(list);
      this.hasAccount = res?.data?.has_account;

      // 只有非搜索条件下，才更新tab列表。理论上tab列表只需要更新一次即可
      // if (!this.form.value.keyword) {
      if (this.listOfPlatforms.length === 1) {
        this.listOfPlatforms = [-1, ...platforms].sort((a, b) => a - b);
      }

      this.refreshCurrentHouseList();
      // console.log("right list of houses: ", this.listOfHouses);
      // console.log("listOfPlatforms: ", this.listOfPlatforms);
    });
  }

  private updateHouseList(list: Array<any>): HouseModel[] {
    return list.map(
      (item) =>
        new HouseModel({
          id: item.origin_house_id,
          origin_house_id: item.origin_house_id,
          title: item.title,
          inventory: item.inventory,
          thirdparty: item.thirdparty_type,
          previewUrl: item.cover_url,
          linkUrl: item.housing_link,
          username: item.thirdparty_account?.username,
          account_id: item.thirdparty_account?.id,
          thumbnail: item.cover_url,
        }),
    );
    return list.map((item) => ({
      ...item,
      id: item.id,
      title: item.title,
      model: new HouseModel({
        id: item.id,
        title: item.title,
        inventory: item.inventory,
        thirdparty: item.thirdparty_type,
        previewUrl: item.housing_link,
        username: item.username,
        thumbnail: _.get(item, "picture_url.small_url"),
      }),
    }));
    _.forEach(list, (item) => {
      const __houseInfo = new HouseModel({
        id: item.id,
        title: item.title,
        inventory: item.inventory,
        thirdparty: item.thirdparty_type,
        previewUrl: item.housing_link,
        username: item.username,
        thumbnail: _.get(item, "picture_url.small_url"),
      });
      _.assign(item, { __houseInfo });
    });
  }

  initScrollContainerListener() {
    console.log("this.scrollContainer: ", this.scrollContainer);
    fromEvent(this.scrollContainer?.nativeElement, "scroll")
      .pipe(takeUntil(this.destroy$), debounceTime(500))
      .pipe(map((rst: Event) => rst.target))
      .subscribe((rst: HTMLElement) => {
        // console.log("SCROLL top:", rst.scrollTop);
        // console.log("scroll height: ", rst.scrollHeight);
        // console.log("client height: ", rst.clientHeight);
        const cacheHeight = 400;
        if (rst.scrollTop + rst.clientHeight + cacheHeight >= rst.scrollHeight) {
          this.onLoadMore();
        }
      });
  }

  onLoadMore() {
    if (this.hasMoreDataFlag) {
      this.page++;
      this.refreshCurrentHouseList();
    }
  }

  onTabChange(index) {
    console.log("on tab change: ", index);
    this.page = 1;
    this.scrollContainer.nativeElement.scrollTop = 0;
    this.refreshCurrentHouseList();
  }

  isNotRecommendedConnectWay(inventory: number) {
    // 多库存关联到房间或者单库存关联到房型，都tip提示
    return (
      (inventory > 1 && this.leftPanelSelectedItem?.type === "house") ||
      (inventory <= 1 && this.leftPanelSelectedItem?.type === "house_type")
    );
  }

  private refreshCurrentHouseList() {
    console.log("current channgel: ", this.currentChannel);
    let list = [];
    if (this.currentChannel === -1) {
      list = this.listOfHouses;
    } else {
      list = this.listOfHouses.filter((item) => item.thirdparty === this.currentChannel);
    }
    this.currentHouseList = list.slice(0, this.page * this.pageSize);

    if (this.currentHouseList.length !== list.length) {
      this.hasMoreDataFlag = true;
    } else {
      this.hasMoreDataFlag = false;
    }

    console.log("current house list: ", this.currentHouseList);
  }

  houseCountByThirdparty(thirdparty) {
    const houses = this.listOfHouses[thirdparty];
    if (this.isAirbnb(thirdparty)) {
      return (
        _.get(houses, [AirbnbLinkType.Official, "length"], 0) + _.get(houses, [AirbnbLinkType.UnOfficial, "length"], 0)
      );
    } else if (this.isOTA(thirdparty)) {
      return _.get(houses, [HouseType.OTA, "length"], 0);
    } else {
      return _.get(houses, [HouseType.Single, "length"], 0) + _.get(houses, [HouseType.Multi, "length"], 0);
    }
    // return this.isAirbnb(thirdparty)
    //   ? _.get(houses, [AirbnbLinkType.Official, "length"], 0) +
    //   _.get(houses, [AirbnbLinkType.UnOfficial, "length"], 0)
    //   : _.get(houses, [HouseType.Single, "length"], 0) +
    //   _.get(houses, [HouseType.Multi, "length"], 0);
  }

  isCtrip(thirdparty) {
    return this.relationSrv.isCtrip(thirdparty);
  }

  isFliggy(thirdparty) {
    return this.relationSrv.isFliggy(thirdparty);
  }

  isAirbnb(thirdparty) {
    return this.relationSrv.isAirbnb(thirdparty);
  }

  isOTA(thirdparty) {
    return this.relationSrv.isOTA(thirdparty);
  }

  ngOnDestroy() {
    this.destroy$.next(null);
    this.destroy$.complete();
  }
}
